'use client'

const comparisonData = [
  {
    feature: 'Email Marketing',
    ordo: { value: 'Built-in', highlight: true },
    birrdi: { value: 'External', highlight: false },
    uschedule: { value: 'External', highlight: false },
    generic: { value: 'External', highlight: false },
  },
  {
    feature: 'Pricing Model',
    ordo: { value: '$199/mo flat', highlight: true },
    birrdi: { value: 'Per-booking fees', highlight: false },
    uschedule: { value: 'Expensive tiers', highlight: false },
    generic: { value: 'Per-seat/per-feature', highlight: false },
  },
  {
    feature: 'Setup Fee',
    ordo: { value: '$0', highlight: true },
    birrdi: { value: '$1,000+', highlight: false },
    uschedule: { value: 'Varies', highlight: false },
    generic: { value: 'Varies', highlight: false },
  },
  {
    feature: 'White-Label Branding',
    ordo: { value: 'Full', highlight: true },
    birrdi: { value: 'Partial', highlight: false },
    uschedule: { value: 'Limited', highlight: false },
    generic: { value: 'No', highlight: false },
  },
  {
    feature: 'Lesson Booking',
    ordo: { value: 'Built-in', highlight: true },
    birrdi: { value: 'Add-on', highlight: false },
    uschedule: { value: 'No', highlight: false },
    generic: { value: 'No', highlight: false },
  },
  {
    feature: 'Modern UI/UX',
    ordo: { value: 'Yes', highlight: true },
    birrdi: { value: 'Yes', highlight: true },
    uschedule: { value: 'Outdated', highlight: false },
    generic: { value: 'Varies', highlight: false },
  },
]

const CheckIcon = () => (
  <svg className="w-5 h-5 text-[#71ED7F]" fill="currentColor" viewBox="0 0 20 20">
    <path
      fillRule="evenodd"
      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
      clipRule="evenodd"
    />
  </svg>
)

const XIcon = () => (
  <svg className="w-5 h-5 text-white/30" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
  </svg>
)

export function CompetitorComparison() {
  return (
    <section className="py-16 sm:py-24">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-12">
          <div className="inline-block px-3 py-1 rounded-full bg-[#71ED7F]/10 border border-[#71ED7F]/20 text-[#71ED7F] text-xs font-semibold uppercase tracking-wider mb-4">
            Comparison
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-medium font-display text-white mb-3">
            Why Facilities Choose Ordo
          </h2>
          <p className="text-white/50 text-sm sm:text-base max-w-lg mx-auto">
            See how we stack up against the alternatives.
          </p>
        </div>

        {/* Desktop Table */}
        <div className="hidden md:block">
          <div className="bg-[#001716] rounded-2xl border border-[#E4FFE7]/[0.08] overflow-hidden shadow-[0_8px_32px_-8px_rgba(0,0,0,0.4)]">
            <table className="w-full">
              <thead>
                <tr className="border-b border-[#E4FFE7]/[0.08]">
                  <th className="text-left p-4 text-sm font-medium text-white/50">Feature</th>
                  <th className="p-4 text-center">
                    <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#71ED7F]/10 border border-[#71ED7F]/20">
                      <img src="/ordo-mark.jpg" alt="Ordo" className="w-5 h-5 rounded-full" />
                      <span className="text-sm font-semibold text-[#71ED7F]">Ordo</span>
                    </div>
                  </th>
                  <th className="p-4 text-center text-sm font-medium text-white/50">Birrdi</th>
                  <th className="p-4 text-center text-sm font-medium text-white/50">USchedule</th>
                  <th className="p-4 text-center text-sm font-medium text-white/50">Generic Tools</th>
                </tr>
              </thead>
              <tbody>
                {comparisonData.map((row, i) => (
                  <tr
                    key={row.feature}
                    className={i !== comparisonData.length - 1 ? 'border-b border-[#E4FFE7]/[0.06]' : ''}
                  >
                    <td className="p-4 text-sm text-white/70">{row.feature}</td>
                    <td className="p-4 text-center">
                      <span
                        className={`inline-flex items-center gap-1.5 text-sm ${
                          row.ordo.highlight ? 'text-[#71ED7F] font-medium' : 'text-white/60'
                        }`}
                      >
                        {row.ordo.highlight && <CheckIcon />}
                        {row.ordo.value}
                      </span>
                    </td>
                    <td className="p-4 text-center">
                      <span
                        className={`inline-flex items-center gap-1.5 text-sm ${
                          row.birrdi.highlight ? 'text-[#71ED7F]' : 'text-white/40'
                        }`}
                      >
                        {row.birrdi.highlight ? <CheckIcon /> : null}
                        {row.birrdi.value}
                      </span>
                    </td>
                    <td className="p-4 text-center">
                      <span
                        className={`inline-flex items-center gap-1.5 text-sm ${
                          row.uschedule.highlight ? 'text-[#71ED7F]' : 'text-white/40'
                        }`}
                      >
                        {row.uschedule.highlight ? <CheckIcon /> : null}
                        {row.uschedule.value}
                      </span>
                    </td>
                    <td className="p-4 text-center">
                      <span
                        className={`inline-flex items-center gap-1.5 text-sm ${
                          row.generic.highlight ? 'text-[#71ED7F]' : 'text-white/40'
                        }`}
                      >
                        {row.generic.highlight ? <CheckIcon /> : null}
                        {row.generic.value}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Mobile Cards */}
        <div className="md:hidden space-y-4">
          {comparisonData.map((row) => (
            <div
              key={row.feature}
              className="bg-[#001716] rounded-xl border border-[#E4FFE7]/[0.08] p-4"
            >
              <h3 className="text-sm font-medium text-white mb-3">{row.feature}</h3>
              <div className="grid grid-cols-2 gap-3">
                <div className="bg-[#71ED7F]/[0.08] rounded-lg p-3 border border-[#71ED7F]/20">
                  <p className="text-[10px] text-white/40 uppercase tracking-wider mb-1">Ordo</p>
                  <p className="text-sm font-medium text-[#71ED7F]">{row.ordo.value}</p>
                </div>
                <div className="bg-white/[0.02] rounded-lg p-3">
                  <p className="text-[10px] text-white/40 uppercase tracking-wider mb-1">Others</p>
                  <p className="text-sm text-white/50">{row.birrdi.value}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom note */}
        <p className="text-center text-white/30 text-xs mt-6">
          Data based on publicly available information as of January 2026.
        </p>
      </div>
    </section>
  )
}
